import DeviceDetector from "../../DeviceDetector";

export default class HelpYouButton {
  constructor() {
    this.deviceDetector = new DeviceDetector();
    this.isMobile = this.deviceDetector.isMobile();

    this.button = document.getElementById("how-can-we-help-you");
    this.button.addEventListener("click", this.howCanWeHelpYou.bind(this));
  }

  howCanWeHelpYou(event) {
    event.preventDefault();
    event.stopPropagation();

    if (this.isMobile === false) {
      console.log(this.scroll);
      this.scroll.scrollTo("#say-hello__heading");
    }

    if (this.isMobile === true) {
      const element = document.getElementById("say-hello__heading");
      element.scrollIntoView();
    }
  }

  setScroll(scroll) {
    if (this.isMobile === false) {
      this.scroll = scroll;
    }
  }
}
